"use strict";
exports.__esModule = true;
exports.createFilterLogic = exports.LOGIC = void 0;
exports.LOGIC = {
    AND: ' and ',
    OR: ' or '
};
function createFilterLogic(logicString) {
    if (!logicString) {
        return null;
    }
    var s = [];
    var subs = [];
    var newLogicString = '';
    var lastEnd = 0;
    for (var i = 0; i < logicString.length; i++) {
        var c = logicString.charAt(i);
        if (c === '(') {
            s.push(i);
        }
        else if (c === ')') {
            var startIndex = s.pop();
            if (s.length === 0) {
                subs.push(logicString.substring(startIndex + 1, i));
                newLogicString += logicString.substring(lastEnd, startIndex + 1);
                lastEnd = i;
            }
        }
    }
    newLogicString += logicString.substring(lastEnd);
    if (subs.length > 0) {
        var logic = newLogicString.indexOf(exports.LOGIC.AND) >= 0 ? exports.LOGIC.AND : exports.LOGIC.OR;
        var groupStr = newLogicString.split(logic).filter(function (s) { return s.trim(); });
        var subIndex_1 = 0;
        var groups = groupStr.map(function (g) {
            if (g === '()') {
                var sub = subs[subIndex_1];
                subIndex_1 += 1;
                return createFilterLogic(sub);
            }
            else {
                return g;
            }
        });
        return new FilterLogic(logic, groups);
    }
    else {
        var logic = logicString.indexOf(exports.LOGIC.AND) >= 0 ? exports.LOGIC.AND : exports.LOGIC.OR;
        var groups = newLogicString.split(logic).filter(function (s) { return s.trim(); });
        return new FilterLogic(logic, groups);
    }
}
exports.createFilterLogic = createFilterLogic;
var FilterLogic = /** @class */ (function () {
    function FilterLogic(logic, groups) {
        if (groups === void 0) { groups = []; }
        this.logic = logic;
        this.children = groups;
    }
    FilterLogic.prototype.addChildGroup = function (group) {
        this.children.push(group);
    };
    FilterLogic.prototype.addChildGroups = function (groups) {
        this.children = this.children.concat(groups);
    };
    FilterLogic.prototype.filter = function (allValidTagSet) {
        this.children = this.children.filter(function (child) {
            if (child instanceof FilterLogic) {
                child.filter(allValidTagSet);
                return child.children.length > 0;
            }
            else {
                if (child.split(':').length === 6) {
                    return true;
                }
                return allValidTagSet.has(child.toString());
            }
        });
    };
    FilterLogic.prototype.toExp = function () {
        return this.children.map(function (child) {
            if (child instanceof FilterLogic) {
                return child.children.length > 1 ? '(' + child.toExp() + ')' : child.toExp();
            }
            else {
                return child.toString();
            }
        }).join(this.logic);
    };
    FilterLogic.prototype.getAllCategoryNames = function () {
        var cateNames = this.children.reduce(function (cateNames, child) {
            if (child instanceof FilterLogic) {
                var c = child.getAllCategoryNames();
                return cateNames.concat(c);
            }
            else {
                if ([2, 3].includes(child.split(':').length)) {
                    cateNames.push(child.split(':')[0]);
                }
                return cateNames;
            }
        }, []);
        var result = [];
        new Set(cateNames).forEach(function (n) { return result.push(n); });
        return result.sort();
    };
    return FilterLogic;
}());
exports["default"] = FilterLogic;
//# sourceMappingURL=filter-logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options2/filter-logic.js